import { IRootState } from '../../../store'
import { IAddMedicationAdministeredState } from '../store/addMedicationAdministered.types'

export const getAddMedicationAdministeredSelector = (state: IRootState): IAddMedicationAdministeredState =>
  state.addMedicationAdministered
